---@meta

---@class Log
---@field executionId string
---@field debug fun(self: Log, ...: any)
---@field info fun(self: Log, ...: any)
---@field warn fun(self: Log, ...: any)
---@field error fun(self: Log, ...: any)

log = {} ---@type Log
